import * as React from "react";
import styled from "styled-components";
import { useContext, useCallback, useState } from "react";
import { Alert, Button, Row } from "components/bootstrap";
import QueryEditModeContext from "views/components/contexts/QueryEditModeContext";
import createParametersFromNames from "enterprise/parameters/components/CreateParametersFromNames";
import useParametersMap from "views/hooks/useParametersMap";
import useUndeclaredParameters from "enterprise/parameters/components/useUndeclaredParameters";
import useViewsDispatch from "views/stores/useViewsDispatch";
import { declareParameters } from "views/logic/slices/searchExecutionSlice";
import ParameterDeclarationForm from "./ParameterDeclarationForm";
const StyledAlert = styled(Alert)`
  margin-bottom: 6px;
`;
const wrapperForMode = (mode) => {
  switch (mode) {
    case "query":
      return ({ children }) => /* @__PURE__ */ React.createElement(Row, null, children);
    case "widget":
      return ({ children }) => /* @__PURE__ */ React.createElement(React.Fragment, null, children);
    default:
      throw new Error(`Invalid query edit mode: ${mode}`);
  }
};
const ParameterBar = () => {
  const [showDeclarationForm, setShowDeclarationForm] = useState(false);
  const existingParameters = useParametersMap();
  const undeclaredParameterNames = useUndeclaredParameters();
  const queryEditContext = useContext(QueryEditModeContext);
  const dispatch = useViewsDispatch();
  const toggleDeclarationForm = useCallback(() => {
    setShowDeclarationForm((cur) => !cur);
  }, []);
  const onSave = useCallback(
    (newParameters) => dispatch(declareParameters(newParameters)).then(() => {
      toggleDeclarationForm();
    }),
    [dispatch, toggleDeclarationForm]
  );
  if (undeclaredParameterNames.size === 0) {
    return null;
  }
  const Wrapper = wrapperForMode(queryEditContext);
  const undeclaredParameters = createParametersFromNames(undeclaredParameterNames);
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "danger", title: `Undeclared query parameters: ${undeclaredParameterNames.join(", ")}` }, /* @__PURE__ */ React.createElement("p", null, "All parameters used in the search query need to be declared before the query can be used:"), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "small", onClick: toggleDeclarationForm }, "Declare parameters")), showDeclarationForm && /* @__PURE__ */ React.createElement(
    ParameterDeclarationForm,
    {
      existingParameters,
      parameters: undeclaredParameters,
      onSave,
      onClose: toggleDeclarationForm
    }
  ));
};
export default ParameterBar;
